"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingDisplay = void 0;
const pubsub_js_1 = require("pubsub-js");
const utils_1 = require("../../utils/utils");
const UiElements_1 = require("../ui/UiElements");
class LoadingDisplay {
    constructor(viewType) {
        let menuEl;
        if (document.querySelector('#flexEmbedLoading') != null) {
            menuEl = document.querySelector('#flexEmbedLoading');
        }
        else {
            menuEl = document.querySelector('#flexMiniEmbedLoading');
        }
        if (!menuEl) {
            throw new Error('flex container is undefined');
        }
        this.loadingElement = this.createElement();
        menuEl.appendChild(this.loadingElement.domEl);
        PubSub.subscribe("toggle-loading-display" /* TOGGLE_LOADING_DISPLAY */, (_, isVisible) => this.toggleVisibility(isVisible));
        (0, pubsub_js_1.subscribe)("background-changed" /* BACKGROUND_CHANGED */, (_, color) => {
            var _a;
            (_a = this.loadingElement) === null || _a === void 0 ? void 0 : _a.setStyle({ 'color': (0, utils_1.colorBasedOnBackground)(color) });
        });
    }
    createElement() {
        return new UiElements_1.DivEl()
            .setId('modelLoadingIndicator')
            .setClass('loading-display')
            .setTextContent("Loading...");
    }
    toggleVisibility(isVisible) {
        var _a;
        const display = isVisible ? '' : 'none';
        (_a = this.loadingElement) === null || _a === void 0 ? void 0 : _a.setStyle({ 'display': display });
    }
}
exports.LoadingDisplay = LoadingDisplay;
